import React from "react"
import classes from "./Rectangle.module.css"
import { classNames } from "@punks/ui-core"

export interface RectangleProps {
  ratio: number
  ratioSm?: number
  ratioMd?: number
  ratioLg?: number
  ratioXl?: number
  children?: any
  center?: boolean
  className?: string
  contentClassName?: string
  style?: React.CSSProperties
}

const Rectangle = ({
  ratio,
  ratioSm,
  ratioMd,
  ratioLg,
  ratioXl,
  children,
  center,
  className,
  contentClassName,
  style,
}: RectangleProps) => {
  return (
    <div
      style={{
        ["--ratio" as any]: `${ratio}%`,
        ["--ratio-sm" as any]: `${ratioSm ?? ratio}%`,
        ["--ratio-md" as any]: `${ratioMd ?? ratioSm ?? ratio}%`,
        ["--ratio-lg" as any]: `${ratioLg ?? ratioMd ?? ratioSm ?? ratio}%`,
        ["--ratio-xl" as any]: `${
          ratioXl ?? ratioLg ?? ratioMd ?? ratioSm ?? ratio
        }%`,
        ...style,
      }}
      className={classNames(classes.root, className)}
    >
      <div
        className={classNames(
          classes.content,
          { [classes.center]: center },
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default Rectangle
